<template>
  <Page>
    <template v-slot:contentTop>
      <div class="pageContent-title">订单列表</div>
      <!-- 基本信息 -->
      <div class="infoView-box">
        <div class="info-title">基本信息</div>
        <div class="info-content">
          <a-form class="flex-form form-label-3" :form="order">
            <div class="grid grid-cols-3 xl:grid-cols-4 gap-2">
              <a-form-item label="订单来源：">
                <span>{{ order.orderSource }}</span>
              </a-form-item>
              <a-form-item label="订单号：">
                <span>{{ order.orderId }}</span>
              </a-form-item>
              <a-form-item label="创建时间：">
                <span>{{ order.createTime }}</span>
              </a-form-item>
              <a-form-item label="订单状态：">
                <span>{{ statusList[order.orderStatus] }}</span>
              </a-form-item>
              <a-form-item label="国家：">
                <span>{{ order.countryName }}</span>
              </a-form-item>
              <a-form-item label="产品名称：">
                <span>{{ order.productName }}</span>
              </a-form-item>
              <a-form-item label="下单企业：">
                <span>{{ order.creatorName }}</span>
              </a-form-item>
              <a-form-item label="供应商名称：">
                <span>{{ order.supplierName }}</span>
              </a-form-item>
              <a-form-item label="操作人：">
                <span>{{ order.operatorName }}</span>
              </a-form-item>
              <a-form-item label="运营端备注：">
                <span>{{ order.adminRemark }}</span>
              </a-form-item>
              <a-form-item label="供应商备注：">
                <span>{{ order.supplierRemark }}</span>
              </a-form-item>
            </div>
          </a-form>
        </div>
      </div>
      <a-divider></a-divider>
      <div class="infoView-box">
        <div class="info-title">申请人列表信息</div>
        <div class="info-content">
          <a-table
            :rowKey="
              (record, index) => {
                return index
              }
            "
            bordered
            :columns="tableColumns"
            :dataSource="dataSource"
          ></a-table>
        </div>
      </div>
    </template>
  </Page>
</template>
<script>
import Page from '@/components/Page'
import { toolMixin } from '@/utils/mixin'
import { orderBranch, orderChannel, transferOrderStatus, transferOrderSubStatus } from '@/vars'

export default {
  mixins: [toolMixin],
  data() {
    const tableColumns = [
      {
        title: '姓名',
        width: '15%',
        align: 'center',
        dataIndex: 'applicantName',
      },
      {
        title: '护照号',
        width: '20%',
        align: 'center',
        dataIndex: 'applicantPassport',
      },
      {
        title: '手机号',
        width: '20%',
        align: 'center',
        dataIndex: 'applicantPhone',
      },
      {
        title: '出签状态',
        width: '20%',
        align: 'center',
        dataIndex: 'applicantStatus',
        customRender: text => {
          return this.transferC[text]
        },
      },
    ]
    return {
      tableColumns,
      statusList: {
        0: '待支付',
        1: '待支付(已创建支付信息)',
        10: '已支付',
        20: '卖家已发货',
        90: '交易成功',
        100: '交易关闭',
      },
      dataSource: [],
      form: this.$form.createForm(this),
      order: {},
      addressData: {},
      saveTipModal: {
        visible: false,
        data: {},
      },
      transferC: {
        1001: '待完善',
        1002: '已填写申请人',
        1003: '已收到资料',
        1004: '已审核完成',
        1005: '已送签',
        1006: '已收到签证结果',
        1007: '已预约面试',
        1010: '已终止办理',
        1012: '需补充材料',
        1013: '已寄回结果',
        1014: '已退回资料',
      },
      editReturnAddress: [],
      customerList: [],
    }
  },
  components: {
    Page,
  },
  computed: {
    typesMap() {
      return {
        orderChannel: orderChannel,
        transferOrderStatus,
        transferOrderSubStatus,
        orderBranch,
        payStatus: [
          { value: 1, label: '待支付' },
          { value: 2, label: '已支付' },
        ],
      }
    },
    returnAddressRemainCustomerList() {
      const result = []
      this.customerList.map(item => {
        // 是否已包含在address中
        const exist = this.editReturnAddress.some(address => {
          return address.addressCustomerList.some(c => {
            return c.orderDetailId === item.orderDetailId
          })
        })
        if (!exist) {
          result.push({
            ...item,
          })
        }
      })
      return result
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      const id = this.$route.query.orderNo
      if (id) {
        this.loadById(id)
      }
    },
    async loadById(orderNo) {
      const res = await this.$axios.get(`/visa/admin/order/${orderNo}`)
      if (res.success) {
        this.order = res.data
        const orderNo = this.order.orderNo
        this.loadSubList(orderNo)
      }
    },
    async loadSubList(id) {
      const res = await this.$axios.get(`/visa/admin/order/${id}/applicant`)
      if (res.success) {
        this.dataSource = res.data
      }
    },
  },
}
</script>

<style lang="less" scoped>
.infoView-box {
  margin-top: 20px;
  .info-title {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 10px;
  }
  .info-content {
    position: relative;
    padding-left: 24px;
    .ant-form-item {
      margin-bottom: 0px;
      label {
        font-weight: bold;
      }
    }
  }
}
.operation-btns {
  margin-top: 24px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  .ant-btn {
    margin-right: 20px;
    &:last-child {
      margin-right: 0;
    }
  }
}
.li-point {
  &::marker {
    color: #ffb831;
  }
}
</style>
